<template>
  <div class="topic-detail">
    <div class="header container">
      <view-back :hideBtn="true"></view-back>
    </div>

    <div class="video-box">
      <!--<img class="flower" :src="projectInfo.cover || bgcDefaultImg" alt="">-->
      <div class="video-show-box wrap">
        <div id="topicDetailVideo" class="video" style="width:800px; height:450px;"></div>
        <!--<video id="topicDetailVideo" class="video" :src="projectInfo.course[curVideoIndex].linkUrl" controls controlslist=”nodownload”></video>-->
        <div v-show="videoPlayBtnShow" class="play-btn" @click="playVideo"></div>
        <div class="course-list">
          <ul>
            <li v-for="(item, index) in projectInfo.course" :key="index" :class="{'selected': index === curVideoIndex}" @click="changeCurVideoIndex(index)">
            <p class="title omitline2 "><span>第{{index + 1}}节：</span>{{item.title}}</p>
            <p class="time">{{item.longer}}</p>
          </li>
          </ul>
        </div>
      </div>
    </div>

    <!--直播信息-->
    <div class="topic-info-box">
      <p class="title">{{projectInfo.title}}</p>
      <div class="avatar-box">
        <p class="name">{{projectInfo.institutionName}}</p>
        <div class="avatar">
          <img :src="util.getPicUrl(projectInfo.institutionHeadImg, 'imgsmall')" alt="">
        </div>
      </div>
      <!--<p class="content">主讲人介绍为贯彻《关于加强文物保护利用改革的若干意见》中关于实施“中华文物全媒体传播计划”的有关要求，落实“互联网+中华文明”行动计划的战略部署，推动文化遗产资源在互联网环境下的活化利用和全媒体传播，在国家文物局的指导下，中国文物报社、腾讯云、微景天下共同发起建设“中华文物云——文化遗产行业云平台”。</p>-->
      <p class="play-num" v-if="projectInfo.course">{{projectInfo.course.length}}节课</p>
    </div>

    <!--课程介绍-->
    <div class="topic-intro">
      <div class="tab-box">
        <p @click="currentIndex = 0" :class="{'selected': currentIndex === 0}">专题介绍</p>
        <p @click="currentIndex = 1" :class="{'selected': currentIndex === 1}">课程列表</p>
      </div>
      <!-- 专题介绍 -->
      <div class="topic-intro-box" v-if="currentIndex === 0">
        {{projectInfo.introduction}}
      </div>
      <!-- 课程列表 -->
      <div class="topic-list-box" v-else>
        <div class="chapter">
          <ul class="clearfix">
            <li v-for="(item, index) in projectInfo.course" :key="index" :class="{'selected': index === curVideoIndex}" @click="changeCurVideoIndex(index)">
              <div class="cover">
                <img :src="util.getPicUrl(item.cover, 'imgoriginal')" alt="">
              </div>
              <p class="title omitline2 "><span>第{{index + 1}}节：</span>{{item.title}}</p>
              <p class="time">{{item.longer}}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ViewBack from '../../components/ViewBack'
import bgcDefaultImg from '../../assets/images/live-flower.png'
export default {
  name: 'topicDetail',
  components: {
    'view-back': ViewBack
  },
  data () {
    return {
      currentIndex: 1, // 默认专题介绍
      bgcDefaultImg: bgcDefaultImg,
      activityType: '',
      id: '', // 专题id
      projectInfo: {}, // 专题info
      curVideoIndex: 0,
      videoPlayBtnShow: true,
      player: null
    }
  },
  created () {
    this.id = this.$route.query.id // 专题id
    this.activityType = this.$route.query.activityType // 回顾 review
    if (this.activityType) {
      this.getThreeActivityTypeInfo()
    } else {
      this.getProjectInfo()
    }
    this.addEvent()
    this.util.addMtah5ClickStat('live_' + this.id)
  },
  mounted () {
  },
  methods: {
    initTcPlayer () {
      this.player = new window.TcPlayer('topicDetailVideo', {
        mp4: this.projectInfo.course[this.curVideoIndex].linkUrl,
        width: 800, // 视频的显示宽度，请尽量使用视频分辨率宽度
        height: 450, // 视频的显示高度，请尽量使用视频分辨率高度
        listener: (msg) => {
          if (msg.type === 'play') {
            this.videoPlayBtnShow = false
          }
          if (msg.type === 'pause') {
            this.videoPlayBtnShow = true
          }
        }
      })
    },
    // 课程跳走
    toPageType (path) {
      // 链接跳走
      window.open(path, '_blank')
    },
    addEvent () {
      let params = {
        statId: this.$store.state.sid,
        eventId: 'live_' + this.id
      }
      this.$api.addEvent(params).then(res => {
      })
    },
    // 获取专题详情
    getProjectInfo () {
      this.$api.getProjectInfo(this.id).then(res => {
        this.projectInfo = res.data.data
        this.projectInfo.course.forEach((item, index) => {
          // 处理直播时长
          item.startTime = item.startTime.split(':')
          item.endTime = item.endTime.split(':')
          let h = item.endTime[0] * 1 - item.startTime[0] * 1
          let m = item.endTime[1] * 1 - item.startTime[1] * 1
          if (m >= 0) { // 正数
          } else { // 非正
            m = 60 + m
          }
          if (m < 10 && m >= 0) {
            m = '0' + m
          }
          if (h < 10 && h >= 0) {
            h = '0' + h
          }
          item.longer = h + ':' + m
        })
        this.initTcPlayer()
      })
    },
    // 获取精品回顾--专题详情页
    getThreeActivityTypeInfo () {
      let params = {
        id: this.id,
        activityType: this.activityType
      }
      this.$api.getThreeActivityTypeInfo({ params: params }).then(res => {
        this.projectInfo = res.data.data.projectInfo
        this.projectInfo.course.forEach((item, index) => {
          // 处理直播时长
          item.startTime = item.startTime.split(':')
          item.endTime = item.endTime.split(':')
          let h = item.endTime[0] * 1 - item.startTime[0] * 1
          let m = item.endTime[1] * 1 - item.startTime[1] * 1
          if (m >= 0) { // 正数
          } else { // 非正
            m = 60 + m
          }
          if (m < 10 && m >= 0) {
            m = '0' + m
          }
          if (h < 10 && h >= 0) {
            h = '0' + h
          }
          item.longer = h + ':' + m
        })
        this.initTcPlayer()
      })
    },
    changeCurVideoIndex (index) {
      if (index === this.curVideoIndex) {
        return
      }
      this.curVideoIndex = index
      this.player.pause()
      this.player.load(this.projectInfo.course[this.curVideoIndex].linkUrl)
      this.videoPlayBtnShow = true
    },
    playVideo () {
      this.player.play()
      this.videoPlayBtnShow = false
    }
  }
}
</script>

<style lang="scss">
  .topic-detail{
    background: #eeeeee;
    padding-bottom: 150px;
    min-width: 1200px;
    .header{
      background: #ffffff;
    }
    .video-box{
      width: 100%;
      /*width: 980px;*/
      background: #000000;
      /*background: linear-gradient(134deg, #54616B 0%, #2A3239 100%);*/
      position: relative;
      /*margin-top: 20px;*/
      margin-bottom: 20px;
      padding: 64px 0;
      .flower{
        width: 702px;
        height: 556px;
        object-fit: cover;
      }
      .video-show-box{
        width: 1120px;
        height: 450px;
        display: flex;
        justify-content: center;
        position: relative;
        .video{
          width: 800px;
          height: 450px;
        }
        .play-btn{
          width: 50px;
          height: 50px;
          background: url("../../assets/images/play-btn.png") no-repeat 0 0;
          background-size: 100% 100%;
          position: absolute;
          left: 375px;
          top: 200px;
          cursor: pointer;
          z-index: 1;
        }
        .course-list{
          width: 320px;
          height: 450px;
          overflow-y: auto;
          -webkit-overflow-scrolling: touch;
          ul{}
          li{
            width: 100%;
            height: 90px;
            position: relative;
            cursor: pointer;
            &::after{
              content: ' ';
              width: 290px;
              height: 1px;
              background: rgba(255,255,255,0.4);
              position: absolute;
              left: 50%;
              bottom: 0;
              margin-left: -145px;
              z-index: 1;
            }
            /*&:nth-last-of-type(1){*/
              /*&::after{*/
                /*display: none;*/
              /*}*/
            /*}*/
            &:hover,&.selected{
              background:rgba(217,169,96,0.3);
            }
          }
          .title{
            font-size: 16px;
            color: #ffffff;
            line-height: 24px;
            width: 290px;
            margin-left: 15px;
            padding-top: 10px;
            span{
              color: #C3864F;
            }
          }
          .time{
            position: absolute;
            right: 15px;
            bottom: 10px;
            font-size: 16px;
            color: rgba(255,255,255,0.4);
            line-height: 16px;
          }
        }
      }
    }
    .topic-info-box{
      padding: 20px 80px 40px;
      width: 820px;
      background: #ffffff;
      margin: 0 auto 20px;
      position: relative;
      .title{
        width: 580px;
        font-size: 24px;
        color: #1B232E;
        letter-spacing: 2px;
        line-height: 40px;
        margin-bottom: 20px;
      }
      .avatar-box{
        width: 100%;
        height: 50px;
        position: relative;
        /*margin-bottom: 20px;*/
        .name{
          padding-left: 70px;
          font-size: 16px;
          color: #4A4A4A;
          letter-spacing: 0;
          line-height: 50px;
        }
        .avatar{
          width: 50px;
          height: 50px;
          background: #d8d8d8;
          position: absolute;
          left: 0;
          top: 0;
          border-radius: 50%;
          overflow: hidden;
          img{
            width: 50px;
            height: 50px;
          }
        }
      }
      .content{
        font-size: 16px;
        color: #4A4A4A;
        line-height: 40px;
      }
      .play-num{
        display: inline-block;
        font-size: 20px;
        color: #4A4A4A;
        line-height: 40px;
        position: absolute;
        right: 80px;
        top: 20px;
        &::before{
          content: ' ';
          width: 29px;
          height: 24px;
          background: url("../../assets/images/live-icon-class.png") no-repeat 0 0;
          background-size: 100% 100%;
          position: absolute;
          left: -37px;
          top: 8px;
        }
      }
    }
    .topic-intro{
      width: 820px;
      padding: 6px 80px 70px;
      background: #ffffff;
      margin: 0 auto;
      .tab-box{
        display: flex;
        justify-content: center;
        border-bottom: 1px solid #D5AA68;
        p{
          display: inline-block;
          font-size: 24px;
          color: #9B9B9B;
          text-indent: 2px;
          letter-spacing: 2px;
          line-height: 24px;
          padding: 24px 0 ;
          position: relative;
          cursor: pointer;
          &:nth-of-type(1){
            margin-right: 250px;
          }
          &.selected{
            color: #D7AE70;
            &::after{
              content: ' ';
              width: 60px;
              height: 4px;
              background: #D5AA68;
              position: absolute;
              left: 50%;
              bottom: 0;
              margin-left: -30px;
            }
          }
        }
      }

      .topic-intro-box{}

      .topic-list-box{
        .chapter{
          margin-bottom: -20px;
          ul{
            margin-top: 40px;
            li{
              float: left;
              width: 400px;
              height: 296px;
              margin-right: 20px;
              margin-bottom: 20px;
              position: relative;
              cursor: pointer;
              box-shadow: 0 0 0 1px #dddddd;
              &:nth-of-type(2n){
                margin-right: 0;
              }
              &.selected,&:hover{
                box-shadow: 0 0 0 2px #D5AA68;
              }
              .cover{
                width: 400px;
                height: 226px;
                background: #d8d8d8;
                font-size: 0;
                margin-bottom: 10px;
                img{
                  width: 400px;
                  height: 226px;
                  object-fit: cover;
                }
              }
              .title{
                font-size: 20px;
                color: #001100;
                line-height: 30px;
                padding: 0 5px;
                width: 350px;
                span{
                  color: #C3864F;
                }
              }
              .time{
                position: absolute;
                right: 0;
                top: 243px;
                font-size: 16px;
                color: #9B9B9B;
                line-height: 16px;
                padding: 0 5px;
              }
            }
          }
        }
      }
    }
    .topic-intro-box {
      text-indent: 2em;
      padding: 39px 0 40px;
      font-size:16px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(74,74,74,1);
      line-height:40px;
    }
  }
</style>
